import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { FloatingPortal, useMergeRefs } from '@floating-ui/react';
import { useBreakpointDown } from '@travel-frontend/core';
import { cloneElement, forwardRef, useRef } from 'react';
import { Arrow } from '../../primitives/Tooltip/Arrow/index.js';
import { Layer } from '../../primitives/Tooltip/Layer/index.js';
import { useTooltip } from '../../primitives/Tooltip/useTooltip.js';
export const Tooltip = forwardRef(({
  open,
  initialOpen,
  placement,
  strategy,
  interactive,
  collisionDetection,
  title,
  content,
  width = 290,
  tooltipElement,
  tooltipText,
  children,
  onOpenChange,
  ...props
}, propRef) => {
  const mdDown = useBreakpointDown('md');
  const arrowRef = useRef(null);
  const tooltip = useTooltip({
    open,
    initialOpen,
    placement,
    strategy,
    interactive: interactive || mdDown,
    collisionDetection,
    arrowRef,
    onOpenChange,
    tooltipElement,
    tooltipText
  });
  const ref = useMergeRefs([tooltip.refs.setReference, propRef]);
  return _jsxs(_Fragment, {
    children: [cloneElement(
    // @ts-expect-error TS(2769) FIXME: No overload matches this call.
    children, tooltip.getReferenceProps({
      ref,
      ...props,
      // @ts-expect-error TS(2533) FIXME: Object is possibly 'null' or 'undefined'.
      ...children.props,
      'data-tooltip-trigger': true,
      'data-tooltip-state': tooltip.open ? 'open' : 'closed'
    })), _jsx(FloatingPortal, {
      id: "portal-root",
      children: tooltip.open && _jsx(Layer, {
        ref: tooltip.refs.setFloating,
        title: title,
        arrow: _jsx(Arrow, {
          ref: arrowRef,
          style: {
            ...tooltip.getArrowStyles()
          }
        }),
        // @ts-expect-error FIXME
        style: {
          ...tooltip.getFloatingStyles(),
          width
        },
        onClose: mdDown ? () => tooltip.setOpen(false) : undefined,
        // @ts-expect-error TS(7006) FIXME: Parameter 'e' implicitly has an 'any' type.
        onClick: e => e.stopPropagation(),
        ...tooltip.getFloatingProps(props),
        children: content
      })
    })]
  });
});